export default __webpack_public_path__ + "static/Location-is-key-for-your-accommodation-price -d325399a1c871be60a85b6c09f31d8d6.jpg";